import { Injectable } from '@angular/core'
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http'
import { Observable } from 'rxjs'
import { environment } from 'src/environments/environment'

@Injectable()
export class FilesCancellationInterceptor implements HttpInterceptor {
    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        const listingUrl = `${environment.api}/s3/files`
        const authorization = request.headers.get('Authorization')
        if (request.method !== 'GET' || request.url !== listingUrl || !authorization) return next.handle(request)

        return new Observable(subscriber => {
            const operationId = crypto.randomUUID()
            const tracked = request.clone({ params: request.params.set('operationId', operationId) })
            let state: 'active' | 'settled' | 'abandoned' = 'active'
            const abandon = () => {
                if (state !== 'active') return
                state = 'abandoned'
                // Retain the dispatched credential across token refresh or account changes.
                try {
                    void fetch(`${listingUrl}/cancel/${operationId}`, {
                        method: 'POST', headers: { Authorization: authorization }, keepalive: true,
                    }).catch(() => undefined)
                } catch {
                    // An unavailable transport still leaves the server's 20-second deadline.
                }
            }
            const pagehide = () => {
                abandon()
                subscriber.complete()
            }
            window.addEventListener('pagehide', pagehide)
            const pending = next.handle(tracked).subscribe({
                next: event => {
                    // firstValueFrom unsubscribes synchronously inside its response handler.
                    if (event instanceof HttpResponse) state = 'settled'
                    subscriber.next(event)
                },
                error: (error: unknown) => {
                    if (error instanceof HttpErrorResponse && error.status === 0) abandon()
                    else state = 'settled'
                    subscriber.error(error)
                },
                complete: () => {
                    state = 'settled'
                    subscriber.complete()
                },
            })
            return () => {
                window.removeEventListener('pagehide', pagehide)
                pending.unsubscribe()
                abandon()
            }
        })
    }
}
